module.exports = __webpack_public_path__ + "img/xt_02.6b5c36d7.png";